<div class="agree-to-understanding">
  By completing this online enrollment application, I understand that I will be submitting an actual enrollment request
  and I agree to the following:
</div>

<h3>STATEMENTS</h3>
<ol class="statements-list">
  <li>
    You do not need more than one Medicare supplement policy.
  </li>
  <li>
    If you purchase this policy, you may want to evaluate your existing health coverage and decide if you need multiple
    coverages.
  </li>
  <li>
    You may be eligible for benefits under Medicaid and may not need a Medicare supplement policy.
  </li>
  <li>
    If, after purchasing this policy, you become eligible for Medicaid, the benefits and premiums under your Medicare
    supplement policy can be suspended, if requested, during your entitlement to benefits under Medicaid for 24 months.
    You must request this suspension within 90 days of becoming eligible for Medicaid. If you are no longer entitled to
    Medicaid, your suspended Medicare supplement policy (or if that is no longer available, a substantially equivalent
    policy) will be reinstituted if requested within 90 days of losing your Medicaid eligibility. If the Medicare
    supplement policy provided coverage for outpatient prescription drugs and you enrolled in Medicare Part D while your
    policy was suspended, the reinstituted policy will not have outpatient prescription drug coverage, but will
    otherwise be substantially equivalent to your coverage before the date of the suspension.
  </li>
  <li>
    If you are eligible for, and have enrolled in a Medicare supplement policy by reason of disability and you later
    become covered by an employer or union-based group health plan, the benefits and premiums under your Medicare
    supplement policy can be suspended, if requested, while you are covered under the employer or union-based group
    health plan. If you suspend your Medicare supplement policy under these circumstances, and later lose your employer
    or union-based group health plan, your suspended Medicare supplement policy (or, if that is no longer available, a
    substantially equivalent policy) will be reinstituted if requested within 90 days of losing your employer or
    union-based group health plan. If the Medicare supplement policy provided coverage for outpatient prescription drugs
    and you enrolled in Medicare Part D while your policy was suspended, the reinstituted policy will not have
    outpatient prescription drug coverage, but will otherwise be substantially equivalent to your coverage before the
    date of the suspension.
  </li>
  <li>
    Counseling services may be available in your state to provide advice concerning your purchase of Medicare supplement
    insurance and concerning medical assistance through the state Medicaid program, including benefits as a Qualified
    Medicare Beneficiary (QMB) and a Specified Low-Income Medicare Beneficiary (SLMB).
  </li>
  <li>
    Premium payments may be made on a calendar month or calendar quarter basis. For example, a monthly premium would be
    for the first day of a month through the last day of such month. A quarterly payment would be for any calendar
    quarterly period, such as January 1 through March 31.
  </li>

</ol>

<h3>AGREEMENT AND CERTIFICATION</h3>
<ol class="agreement-and-certification-list">
  <li>
    I hereby apply for coverage with Blue Cross Blue Shield of Wyoming under the terms and conditions as stated in the
    Medicare Supplement Agreement, and as provided for under applicable State or Federal law, including the
    non-duplication provisions which preclude duplication of payment for services, portability of pre-existing
    conditions and coverage replacement provisions.
  </li>
  <li>
    I hereby certify that the statements made on this application are true; that this application correctly describes my
    present health status; and that I am in good health except as expressly explained in the application.
  </li>
  <li>
    I understand that Blue Cross Blue Shield of Wyoming reserves the right to accept or decline this application in
    whole or in part as provided by State or Federal law. I further understand I will not be eligible for coverage until
    the Medicare Supplement Agreement is actually issued by Blue Cross Blue Shield of Wyoming. (I will be notified of
    the effective date if accepted.)
  </li>
  <li>
    I realize that any misrepresentations or omissions in the application will invalidate the Agreement.
  </li>
  <li>
    I understand that upon acceptance of my application, my coverage will become effective on the date established by
    Blue Cross Blue Shield of Wyoming and that the Medicare Supplement Agreement together with this application or
    applicable documents, shall constitute my entire agreement with Blue Cross Blue Shield of Wyoming.
  </li>
  <li>
    I realize that any deposit of dues by Blue Cross Blue Shield of Wyoming does not constitute acceptance of this
    application and does not waive any right to deny this application.
  </li>
  <li>
    I understand that no condition will be covered under the terms of this Agreement if medical advice was given, or
    treatment was recommended by, or received from, a physician within 90 days before the effective date of the
    coverage, until 2 months after the effective date of coverage.
  </li>
</ol>
